import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

export function canShowWarranty(duration: number | Nullish, termsText: string | null) {
  return isNotNil(duration) || isNotNil(termsText);
}
